export const isNotBlankArray = (item) => {
    if (Array.isArray(item) && 0 in new Object(item)) {
        return true;
    }
    return false;
};
export const getImg = (language) => {
    const REDEEMEDSTAMP = {
        "en": "https://i.ezbuy.sg/FphReuXh0Mlz5p31rqKnznJh6NWi",
        "zh": "https://i.ezbuy.sg/FvX7n8oLj1ZguZHRnM8ZmFy7xS4d",
        "zhtw": "https://i.ezbuy.sg/FtdIBG5KlKRUqN3o7nhFMRFkUBtU",
        "th": "https://i.ezbuy.sg/Fh_CcwdheqiunIPlT_Vr2EAg-DqH",
        "ms": "https://i.ezbuy.sg/Fqx0LXcGPYtwLLKkcOT-uWvieEsc"
    };
    return REDEEMEDSTAMP[language];
};
